export default __webpack_public_path__ + "static/media/EasterDay_11.498cd748.png";